import { withQueryParams } from '@/lib/url';
import { EditorType, type DevicePreset } from '@/types/feedback';

const isDev = process.env.NODE_ENV === 'development';
const appBasePath = (process.env.domain ?? '').replace(/\/$/, '');

export type PreviewFrameUrlOptions = {
  editorType?: EditorType;
  device?: DevicePreset;
};

export function needsClassicEditorMobileView(
  editorType?: EditorType,
  device?: DevicePreset,
): boolean {
  return editorType === EditorType.Editor && device !== 'desktop';
}

export function buildPreviewSiteUrl(
  siteUrl: string,
  options: PreviewFrameUrlOptions = {},
): string {
  const params: Record<string, string> = { rc: 'FEEDBACK' };

  if (needsClassicEditorMobileView(options.editorType, options.device)) {
    params.showMobileView = 'true';
  }

  return withQueryParams(siteUrl, params);
}

export function buildPreviewFrameUrl(
  siteUrl: string,
  options: PreviewFrameUrlOptions = {},
): string {
  const siteUrlWithParams = buildPreviewSiteUrl(siteUrl, options);

  if (isDev) {
    return `${appBasePath}/api/proxy?url=${encodeURIComponent(siteUrlWithParams)}`;
  }

  return siteUrlWithParams;
}
